import React, { useState, useEffect } from "react";
import { withRouter, useParams } from "react-router-dom";
import { connect } from "react-redux";

import styles from "./Questionnaire.module.scss";
import { saveVendorAuditAffiliateAction, readVendorAuditTokenAffiliateAction } from "store/actions/Actions";

const data = {
    1: {
        id: '1',
        title: 'Build and Maintain a Secure Network',
        desc: 'Requirement 1: Install and maintain a firewall configuration to protect data',
        questions: {
            1: {
                id: '1.1',
                question: 'Are all router, switches, wireless access points, and firewall configurations secured and do they conform to documented security standards?',
                answer: 'No',
            },
            2: {
                id: '1.2',
                question: 'If wireless technology is used, is the access to the network limited to authorized devices?',
                answer: 'No',
            },
            3: {
                id: '1.3',
                question: 'Do changes to the firewall need authorization and are the changes logged?',
                answer: 'No',
            },
            4: {
                id: '1.4',
                question: 'Is a firewall used to protect the network and limit traffic to that which is required to conduct business?',
                answer: 'No',
            },
            5: {
                id: '1.5',
                question: 'Are egress and ingress filters installed on all border routers to prevent impersonation with spoofed IP addresses?',
                answer: 'No',
            },
            6: {
                id: '1.6',
                question: 'Is payment card account information stored in a database located on the internal network (not the DMZ) and protected by a firewall?',
                answer: 'No',
            },
            7: {
                id: '1.7',
                question: 'If wireless technology is used, do perimeter firewalls exist between wireless networks and the payment card environment?',
                answer: 'No',
            },
            8: {
                id: '1.8',
                question: 'Does each mobile computer with direct connectivity to the Internet have a personal firewall and anti-virus software installed?',
                answer: 'No',
            },
            9: {
                id: '1.9',
                question: 'Are Web servers located on a publicly reachable network segment separated from the internal network by a firewall (DMZ)?',
                answer: 'No',
            },
            10: {
                id: '1.10',
                question: 'Is the firewall configured to translate (hide) internal IP addresses, using network address translation (NAT)?',
                answer: 'No',
            },
        },
    },
    2 : {
        id: '2',
        title: 'Build and Maintain a Secure Network',
        desc: 'Requirement 2: Do not use vendor-supplied defaults for system passwords and other security parameters',
        questions: {
            1: {
                id: '2.1',
                question: 'Are vendor default security settings changed on production systems before taking the system into production?',
                answer: 'No',
            },
            2: {
                id: '2.2',
                question: 'Are vendor default accounts and passwords disabled or changed on production systems before putting a system into production?',
                answer: 'No',
            },
            3: {
                id: '2.3',
                question: 'If wireless technology is used, are vendor default settings changed (i.e. WEP keys, SSID, passwords, SNMP community strings, disabling SSID broadcasts)?',
                answer: 'No',
            },
            4: {
                id: '2.4',
                question: 'If wireless technology is used, is Wi-Fi Protected Access (WPA) technology implemented for encryption and authentication when WPA-capable?',
                answer: 'No',
            },
            5: {
                id: '2.5',
                question: 'Are all production systems (servers and network components) hardened by removing all unnecessary services and protocols installed by the default configuration?',
                answer: 'No',
            },
            6: {
                id: '2.6',
                question: 'Are secure, encrypted communications used for remote administration of production systems and applications?',
                answer: 'No',
            },
        },
    },
    3: {
        id: '3',
        title: 'Protect Cardholder Data',
        desc: 'Requirement 3: Protect stored data',
        questions: {
            1: {
                id: '3.1',
                question: 'Is sensitive cardholder data securely disposed of when no longer needed?',
                answer: 'No',
            },
            2: {
                id: '3.2',
                question: 'Is it prohibited to store the full contents of any track from the magnetic stripe (on the back of the card, in a chip, etc.) in the database, log files, or point-of-sale products?',
                answer: 'No',
            },
            3: {
                id: '3.3',
                question: 'Is it prohibited to store the card-validation code (three-digit value printed on the signature panel of a card) in the database, log files, or point-of-sale products?',
                answer: 'No',
            },
            4: {
                id: '3.4',
                question: 'Are all but the last four digits of the account number masked when displaying cardholder data?',
                answer: 'No',
            },
            5: {
                id: '3.5',
                question: 'Are account numbers (in databases, logs, files, backup media, etc.) stored securely— for example, by means of encryption or truncation?',
                answer: 'No',
            },
            6: {
                id: '3.6',
                question: 'Are account numbers sanitized before being logged in the audit log?',
                answer: 'No',
            },
        },
    },
    4: {
        id: '4',
        title: 'Protect Cardholder Data',
        desc: 'Requirement 4: Encrypt transmission of cardholder data and sensitive information across public networks',
        questions: {
            1: {
                id: '4.1',
                question: 'Are transmissions of sensitive cardholder data encrypted over public networks through the use of SSL or other industry acceptable methods?',
                answer: 'No',
            },
            2: {
                id: '4.2',
                question: 'If SSL is used for transmission of sensitive cardholder data, is it using version 3.0 with 128-bit encryption?',
                answer: 'No',
            },
            3: {
                id: '4.3',
                question: 'If wireless technology is used, is the communication encrypted using Wi-Fi Protected Access (WPA), LEAP, VPN, SSL at 128-bit, or WEP?',
                answer: 'No',
            },
            4: {
                id: '4.4',
                question: 'If wireless technology is used, are WEP at 128-bit and additional encryption technologies in use, and are shared WEP keys rotated quarterly?',
                answer: 'No',
            },
            5: {
                id: '4.5',
                question: 'Is encryption used in the transmission of account numbers via e-mail?',
                answer: 'No',
            },
        },
    },
    5: {
        id: '5',
        title: 'Maintain a Vulnerability Management Program',
        desc: 'Requirement 5: Use and regularly update anti-virus software',
        questions: {
            1: {
                id: '5.1',
                question: 'Is there a virus scanner installed on all servers and on all workstations, and is the virus scanner regularly updated?',
                answer: 'No',
            },
        },
    },
    6: {
        id: '6',
        title: 'Maintain a Vulnerability Management Program',
        desc: 'Requirement 6: Develop and maintain secure systems and applications',
        questions: {
            1: {
                id: '6.1',
                question: 'Are development, testing, and production systems updated with the latest security-related patches released by the vendors?',
                answer: 'No',
            },
            2: {
                id: '6.2',
                question: 'Is the software and application development process based on an industry best practice and is information security included throughout the software development life cycle (SDLC) process?',
                answer: 'No',
            },
            3: {
                id: '6.3',
                question: 'If production data is used for testing and development purposes, is sensitive cardholder data sanitized before usage?',
                answer: 'No',
            },
            4: {
                id: '6.4',
                question: 'Are all changes to the production environment and applications formally authorized, planned, and logged before being implemented?',
                answer: 'No',
            },
            5: {
                id: '6.5',
                question: 'Were the guidelines commonly accepted by the security community (such as Open Web Application Security Project group (www.owasp.org)) taken into account in the development of Web applications?',
                answer: 'No',
            },
            6: {
                id: '6.6',
                question: 'When authenticating over the Internet, is the application designed to prevent malicious users from trying to determine existing user accounts?',
                answer: 'No',
            },
            7: {
                id: '6.7',
                question: 'Is sensitive cardholder data stored in cookies secured or encrypted?',
                answer: 'No',
            },
            8: {
                id: '6.8',
                question: 'Are controls implemented on the server side to prevent SQL injection and other bypassing of client side-input controls?',
                answer: 'No',
            },
        },
    },
    7: {
        id: '7',
        title: 'Implement Strong Access Control Measures',
        desc: 'Requirement 7: Restrict access to data by business need-to-know',
        questions: {
            1: {
                id: '7.1',
                question: 'Is access to payment card account numbers restricted for users on a need-to-know basis?',
                answer: 'No',
            },
        },
    },
    8: {
        id: '8',
        title: 'Implement Strong Access Control Measures',
        desc: 'Requirement 8: Assign a unique ID to each person with computer access',
        questions: {
            1: {
                id: '8.1',
                question: 'Are all users required to authenticate using, at a minimum, a unique username and password?',
                answer: 'No',
            },
            2: {
                id: '8.2',
                question: 'If employees, administrators, or third parties access the network remotely, is remote access software (such as PCAnywhere, dial-in, or VPN) configured with a unique username and password and with encryption and other security features turned on?',
                answer: 'No',
            },
            3: {
                id: '8.3',
                question: 'Are all passwords on network devices and systems encrypted?',
                answer: 'No',
            },
            4: {
                id: '8.4',
                question: 'When an employee leaves the company, are that employee’s user accounts and passwords immediately revoked?',
                answer: 'No',
            },
            5: {
                id: '8.5',
                question: 'Are all user accounts reviewed on a regular basis to ensure that malicious, out-of-date, or unknown accounts do not exist?',
                answer: 'No',
            },
            6: {
                id: '8.6',
                question: 'Are non-consumer accounts that are not used for a lengthy amount of time (inactive accounts) automatically disabled in the system after a pre-defined period?',
                answer: 'No',
            },
            7: {
                id: '8.7',
                question: 'Are accounts used by vendors for remote maintenance enabled only during the time needed?',
                answer: 'No',
            },
            8: {
                id: '8.8',
                question: 'Are group, shared, or generic accounts and passwords prohibited for non-consumer users?',
                answer: 'No',
            },
            9: {
                id: '8.9',
                question: 'Are non-consumer users required to change their passwords on a predefined regular basis?',
                answer: 'No',
            },
            10: {
                id: '8.10',
                question: 'Is there a password policy for non-consumer users that enforces the use of strong passwords and prevents the resubmission of previously used passwords?',
                answer: 'No',
            },
            11: {
                id: '8.11',
                question: 'Is there an account-lockout mechanism that blocks a malicious user from obtaining access to an account by multiple password retries or brute force?',
                answer: 'No',
            },
        },
    },
    9: {
        id: '9',
        title: 'Implement Strong Access Control Measures',
        desc: 'Requirement 9: Restrict physical access to cardholder data',
        questions: {
            1: {
                id: '9.1',
                question: 'Are there multiple physical security controls (such as badges, escorts, or mantraps) in place that would prevent unauthorized individuals from gaining access to the facility?',
                answer: 'No',
            },
            2: {
                id: '9.2',
                question: 'If wireless technology is used, do you restrict access to wireless access points, wireless gateways, and wireless handheld devices?',
                answer: 'No',
            },
            3: {
                id: '9.3',
                question: 'Are equipment (such as servers, workstations, laptops, and hard drives) and media containing cardholder data physically protected against unauthorized access?',
                answer: 'No',
            },
            4: {
                id: '9.4',
                question: 'Is all cardholder data printed on paper or received by fax protected against unauthorized access?',
                answer: 'No',
            },
            5: {
                id: '9.5',
                question: 'Are procedures in place to handle secure distribution and disposal of backup media and other media containing sensitive cardholder data?',
                answer: 'No',
            },
            6: {
                id: '9.6',
                question: 'Are all media devices that store cardholder data properly inventoried and securely stored?',
                answer: 'No',
            },
            7: {
                id: '9.7',
                question: 'Is cardholder data deleted or destroyed before it is physically disposed (for example, by shredding papers or degaussing backup media)?',
                answer: 'No',
            },
        },
    },
    10: {
        id: '10',
        title: 'Regularly Monitor and Test Networks',
        desc: 'Requirement 10: Track and monitor all access to network resources and cardholder data',
        questions: {
            1: {
                id: '10.1',
                question: 'Is all access to cardholder data, including root/administration access, logged?',
                answer: 'No',
            },
            2: {
                id: '10.2',
                question: 'Do access control logs contain successful and unsuccessful login attempts and access to audit logs?',
                answer: 'No',
            },
            3: {
                id: '10.3',
                question: 'Are all critical system clocks and times synchronized, and do logs include date and time stamp?',
                answer: 'No',
            },
            4: {
                id: '10.4',
                question: 'Are the firewall, router, wireless access points, and authentication server logs regularly reviewed for unauthorized traffic?',
                answer: 'No',
            },
            5: {
                id: '10.5',
                question: 'Are audit logs regularly backed up, secured, and retained for at least three months online and one-year offline for all critical systems?',
                answer: 'No',
            },
        },
    },
    11: {
        id: '11',
        title: 'Regularly Monitor and Test Networks',
        desc: 'Requirement 11: Regularly test security systems and processes',
        questions: {
            1: {
                id: '11.1',
                question: 'If wireless technology is used, is a wireless analyzer periodically run to identify all wireless devices?',
                answer: 'No',
            },
            2: {
                id: '11.2',
                question: 'Is a vulnerability scan or penetration test performed on all Internetfacing applications and systems before they go into production?',
                answer: 'No',
            },
            3: {
                id: '11.3',
                question: 'Is a intrusion detection or intrusion prevention system used on the network?',
                answer: 'No',
            },
            4: {
                id: '11.4',
                question: 'Are security alerts from the intrusion detection or intrusion prevention system (IDS/IPS) continuously monitored, and are the latest IDS/IPS signatures installed?',
                answer: 'No',
            },
        },
    },
    12: {
        id: '12',
        title: 'Maintain a policy that addresses information security',
        desc: 'Requirement 12: Maintain a policy that addresses information security',
        questions: {
            1: {
                id: '12.1',
                question: 'Are information security policies, including policies for access control, application and system development, operational, network and physical security, formally documented?',
                answer: 'No',
            },
            2: {
                id: '12.2',
                question: 'Are information security policies and other relevant security information disseminated to all system users (including vendors, contractors, and business partners)?',
                answer: 'No',
            },
            3: {
                id: '12.3',
                question: 'Are information security policies reviewed at least once a year and updated as needed?',
                answer: 'No',
            },
            4: {
                id: '12.4',
                question: 'Have the roles and responsibilities for information security been clearly defined within the company?',
                answer: 'No',
            },
            5: {
                id: '12.5',
                question: 'Is there an up-to-date information security awareness and training program in place for all system users?',
                answer: 'No',
            },
            6: {
                id: '12.6',
                question: 'Are employees required to sign an agreement verifying they have read and understood the security policies and procedures?',
                answer: 'No',
            },
            7: {
                id: '12.7',
                question: 'Is a background investigation (such as a credit- and criminal-record check, within the limits of local law) performed on all employees with access to account numbers?',
                answer: 'No',
            },
            8: {
                id: '12.8',
                question: 'Are all third parties with access to sensitive cardholder data contractually obligated to comply with card association security standards?',
                answer: 'No',
            },
            9: {
                id: '12.9',
                question: 'Is a security incident response plan formally documented and disseminated to the appropriate responsible parties?',
                answer: 'No',
            },
            10: {
                id: '12.10',
                question: 'Are security incidents reported to the person responsible for security investigation?',
                answer: 'No',
            },
            11: {
                id: '12.11',
                question: 'Is there an incident response team ready to be deployed in case of a cardholder data compromise?',
                answer: 'No',
            },
        },
    },
};

const Questionnaire = (props) => {

    const { readVendorAuditTokenAffiliateAction, saveVendorAuditAffiliateAction, AffiliatesAuditReducer } = props;

    const [audit, setAudit] = useState(data);
    let { hash } = useParams();
    const [isCompleted, setCompleted] = useState(true);

    useEffect(() => {
        if (!AffiliatesAuditReducer.audit) {
            readVendorAuditTokenAffiliateAction({ token: hash });
        }

        if (AffiliatesAuditReducer.audit) {
            setCompleted(AffiliatesAuditReducer.audit.audit_complete === "t" ? true : false);
        }

    }, [readVendorAuditTokenAffiliateAction, AffiliatesAuditReducer.audit, hash]);

    const handleCheckbox = (e) => {
        try {
            const a = Object.assign({}, audit);
            a[e.target.dataset.sid].questions[e.target.dataset.qid].answer = e.target.value;
            setAudit(a);
        } catch (error) {
            console.log('error handle checkbox!');            
        }
    };

    const handleSubmit = () => {
        saveVendorAuditAffiliateAction({ token: hash, audit_json: audit });
    }

    return (
        <div className={styles.container} style={{ margin: '0 20px' }}>
            {!isCompleted &&
            <>
                <div className={styles.holder}>
                    {Object.values(audit).map((section) => {
                        return <div key={section.id}>
                            <div className={styles.section_head}>
                                <div>{section.title}</div>
                                <div>{section.desc}</div>
                            </div>
                            <div>
                                <div className={styles.questions}>
                                {Object.values(section.questions).map((q, id) => {
                                    return <div key={`${q.id}-all`}>
                                        <span>{q.id}</span>
                                        <span>{q.question}</span>
                                        <span>
                                            <input type="radio" id={`${q.id}-yes`} onChange={handleCheckbox} data-sid={section.id} data-qid={id + 1} name={`${q.id}-q`} value="Yes" defaultChecked={q.answer === 'Yes' ? true : false} />
                                            <label htmlFor={`${q.id}-yes`}>Yes</label>
                                            <input type="radio" id={`${q.id}-no`} onChange={handleCheckbox} data-sid={section.id} data-qid={id + 1} name={`${q.id}-q`} value="No" defaultChecked={q.answer === 'No' ? true : false} />
                                            <label htmlFor={`${q.id}-no`}>No</label>
                                            <input type="radio" id={`${q.id}-na`} onChange={handleCheckbox} data-sid={section.id} data-qid={id + 1} name={`${q.id}-q`} value="NA" defaultChecked={q.answer === 'NA' ? true : false} />
                                            <label htmlFor={`${q.id}-na`}>Not Applicable</label>
                                        </span>
                                    </div>
                                })}
                                </div>
                            </div>
                        </div>
                    })}
                </div>
                <div className={styles.submit}>
                    <button type='submit' onClick={handleSubmit}>Submit Questionnaire</button>
                    <br /><br /><br />
                </div>
            </>
            }
            {isCompleted && 
            <div className={styles.completed}>
                <div>
                    Thank you for completing the questionnaire!
                </div>
            </div>
            }
            <div className={styles.copyright}>
                <p>Copyright &#169; 2022 Compliancy Group, LLC. All Rights Reserved</p>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    AffiliatesAuditReducer: state.AffiliatesAuditReducer,
});

const mapDispatchToProps = {
    readVendorAuditTokenAffiliateAction,
    saveVendorAuditAffiliateAction,
};

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Questionnaire));
